import React from 'react';
import { SPaginationButton } from './styled/SPagination';
import { Flex } from '@rebass/grid';
import Icon from '../icon/Icon';
import colors from '../../theme/Colors';
import { useTranslation } from 'react-i18next';

interface PaginationProps {
    firstUrl: string;
    lastUrl: string;
    nextUrl: string;
    previousUrl: string;
    onFirst: () => void;
    onLast: () => void;
    onNext: () => void;
    onPrevious: () => void;
    onPage: Function;
    pages: number;
    currentPage: number;
}

function getArrowColor() {
    if (window.location.host.includes('bcd')) {
        return colors.bcd.secondary;
    }
    return colors.brenntag.primary;
}

function goToPage(onPage: Function, firstUrl: string, pageToGo: number) {
    function go() {
        onPage(firstUrl, pageToGo);
    }
    return go;
}



const Pagination: React.FC<PaginationProps> = ({children, firstUrl, lastUrl, nextUrl, previousUrl, onFirst, onLast, onNext, onPrevious, onPage, pages, currentPage}) => {

    const {t} = useTranslation();

    function getSlice(currentPage: number, pages: number) {
        let start = Math.max(currentPage - 2, 1)
        const end = Math.min(start + 4, pages)
        start = Math.max(end - 4, 1)

        return Array(end - start + 1).fill(start).map((v, k) => v + k)
    }

    return <Flex id='box-pagination' justifyContent='space-around'>
        <SPaginationButton id='pagination-first-button' disabled={!firstUrl || !previousUrl} onClick={onFirst}>{t("FIRST")}</SPaginationButton>
        <SPaginationButton id='pagination-previous-button' disabled={!previousUrl} onClick={onPrevious}><Icon name='arrow_left' color={!previousUrl ? '#999999' : getArrowColor()}/></SPaginationButton>
        {getSlice(currentPage, pages).map((item, index) => <SPaginationButton id={`pagination-${item}-button`} active={item === currentPage} key={index} onClick={goToPage(onPage, firstUrl, item)}>{item}</SPaginationButton>)}
        <SPaginationButton id='pagination-next-button' disabled={!nextUrl} onClick={onNext}><Icon name='arrow_right' color={!nextUrl ? '#999999' : getArrowColor()}/></SPaginationButton>
        <SPaginationButton id='pagination-last-button' disabled={!lastUrl || !nextUrl} onClick={onLast}>{t("LAST")}</SPaginationButton>
    </Flex>

};

export default Pagination;
